/* Lace Safety Vest Amazon routing, full rollout v2.1.
 * All mapped styles/colors route to their Large ASIN.
 * Product-page Amazon USA buttons always use amazon.com.
 * Paid Meta, brand Instagram, Alejandra, and other website traffic use their configured tags.
 * Direct social links support US/Mexico routing; language does not select the marketplace.
 * Enabled when installed. This comment does not assert deployment or verified Amazon reporting.
 */
(function () {
  'use strict';
  if (window.LSVAmazon) return;
  var ASINS = {
  "VEST002-B-NP-L": "B0FR9TH7WZ",
  "VEST002-B-P-L": "B0FR8XQ1NR",
  "VEST002-BLU-NP-L": "B0G1MYYY98",
  "VEST002-BLU-P-L": "B0G1N2R9Z7",
  "VEST002-O-NP-L": "B0FR9C56VF",
  "VEST002-O-P-L": "B0FR9TJLTX",
  "VEST002-P-NP-L": "B0FR9SH3DR",
  "VEST002-P-P-L": "B0FR8FTL39",
  "VEST002-PUR-NP-L": "B0G1MTVTXH",
  "VEST002-PUR-P-L": "B0G1MT8NW5",
  "VEST002-R-NP-L": "B0G1MZ8TZR",
  "VEST002-R-P-L": "B0G1N3QN11",
  "VEST002-Y-HP-L": "B0GRVLKH8K",
  "VEST002-Y-NP-BW-L": "B0GD8HDSQ4",
  "VEST002-Y-NP-L": "B0FR9GMHS9",
  "VEST002-Y-NP-X-L": "B0H6BS9D5Z",
  "VEST002-Y-P-L": "B0FR9TNRWP",
  "VEST002-Y-SP-L": "B0GD8CCT13"
};
  var LINKS = {
  "alejandra_us": "https://www.amazon.com/dp/B0FR9TNRWP?maas=maas_adg_4DA7709FC82A2D51A9DA25B09E9068A3_afap_abs&ref_=aa_maas&tag=maas",
  "alejandra_mx": "https://www.amazon.com.mx/dp/B0FR9TNRWP?maas=maas_adg_D1498CEF84202EB8542E5593CB02D3E0_afap_abs&ref_=aa_maas&tag=maas",
  "brand_instagram_us": "https://www.amazon.com/dp/B0FR9TNRWP?maas=maas_adg_CC99EBA568FCF5AF92BDB61AAD92A45D_afap_abs&ref_=aa_maas&tag=maas",
  "brand_instagram_mx": "https://www.amazon.com.mx/dp/B0FR9TNRWP?maas=maas_adg_9AEE6F27241713174895F621904845CD_afap_abs&ref_=aa_maas&tag=maas",
  "meta_paid_us": "https://www.amazon.com/dp/B0FR9TNRWP?maas=maas_adg_063F489BC63E0ABF6B05BBA018EDFB45_afap_abs&ref_=aa_maas&tag=maas",
  "website_other_us": "https://www.amazon.com/dp/B0FR9TNRWP?maas=maas_adg_16E48DC4CB0286FA27B9119A51AD9AF7_afap_abs&ref_=aa_maas&tag=maas"
};
  var DEFAULT_SKU = 'VEST002-Y-P-L';
  var SOURCES = ['website_other', 'meta_paid', 'brand_instagram', 'alejandra'];
  var KEY = 'lsv_amazon_source_v2';
  var IDLE = 30 * 60 * 1000;
  var remembered = null;
  var ready = false;
  var redirected = false;
  var timer;
  var p = new URLSearchParams(location.search);

  function lower(value) { return String(value || '').trim().toLowerCase(); }
  function largeSku(sku) {
    return String(sku || '').trim().toUpperCase().replace(/-FBA$/, '')
      .replace(/-(?:XS|S|M|L|XL|2XL|3XL|XXL|XXXL)$/, '-L');
  }
  function mappedSku(sku) {
    sku = largeSku(sku);
    return Object.prototype.hasOwnProperty.call(ASINS, sku) ? sku : DEFAULT_SKU;
  }
  function classify(search) {
    var q = new URLSearchParams(search);
    var sources = q.getAll('utm_source').map(lower);
    var medium = lower(q.get('utm_medium'));
    var explicit = lower(q.get('source'));
    if (['paid_social','paid-social','paid','cpc','ppc'].indexOf(medium) !== -1 &&
        sources.some(function (s) {return ['meta','facebook','instagram','fb','ig'].indexOf(s) !== -1;})) return 'meta_paid';
    if (explicit === 'alejandra' || sources.some(function (s) {
      return ['alejandra','alejandra-ig','alejandra-fb'].indexOf(s) !== -1;
    }) || lower(q.get('utm_campaign')) === 'alejandra') return 'alejandra';
    if (explicit === 'brand_instagram' || sources.some(function (s) {
      return ['instagram','brand_instagram','ig-dm-mx'].indexOf(s) !== -1;
    })) return 'brand_instagram';
    if (q.has('source') || q.has('utm_source') || q.has('utm_medium') || q.has('utm_campaign')) return 'website_other';
    return null;
  }
  function allowed() {
    try { return !!window.Shopify.customerPrivacy.marketingAllowed(); }
    catch (e) { return false; }
  }
  function saved() {
    if (!allowed()) return null;
    try {
      var s = JSON.parse(sessionStorage.getItem(KEY));
      if (s && SOURCES.indexOf(s.source) !== -1 && s.lastSeen <= Date.now() &&
          Date.now() - s.lastSeen < IDLE) return s.source;
    } catch (e) {}
    return null;
  }
  function currentSource() { return classify(location.search) || remembered || saved() || 'website_other'; }
  function capture() {
    if (!allowed()) {
      remembered = null;
      try { sessionStorage.removeItem(KEY); } catch (e) {}
      return;
    }
    remembered = classify(location.search) || saved() || 'website_other';
    try { sessionStorage.setItem(KEY, JSON.stringify({source:remembered,lastSeen:Date.now()})); } catch (e) {}
  }
  function selectedSku(button) {
    var form = document.getElementById(button.getAttribute('data-lsv-form-id'));
    if (!form) return DEFAULT_SKU;
    var input = form.querySelector('[name="id"]');
    var data = form.querySelector('[data-lsv-amazon-variants]');
    if (!input || !data) return DEFAULT_SKU;
    try {
      var v = JSON.parse(data.textContent).find(function (v) { return String(v.id) === String(input.value); });
      return mappedSku(v && v.sku);
    } catch (e) { return DEFAULT_SKU; }
  }
  function updateButton(button) {
    // Preserve the original product-button navigation: direct Amazon URL, new tab.
    button.href = destination(currentSource(),'us',selectedSku(button),allowed());
    button.target = '_blank';
    button.rel = 'noopener noreferrer';
  }
  function refreshButtons() { document.querySelectorAll('[data-lsv-amazon]').forEach(updateButton); }
  function country() {
    // Shopify's detected region takes priority. Time zone is only a fallback estimate.
    try {
      var region = window.Shopify.customerPrivacy.getRegion();
      if (region && /^[A-Za-z]{2}/.test(region)) return region.slice(0,2).toUpperCase();
    } catch (e) {}
    try {
      var tz = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
      if (/^(America\/(Mexico_City|Cancun|Merida|Monterrey|Matamoros|Chihuahua|Ciudad_Juarez|Ojinaga|Mazatlan|Bahia_Banderas|Hermosillo|Tijuana|Ensenada|Santa_Isabel)|Mexico\/(General|BajaNorte|BajaSur))$/.test(tz)) return 'MX';
    } catch (e) {}
    return 'US';
  }
  function marketFor(query, source, detectedCountry) {
    var q = new URLSearchParams(query);
    if (q.get('entry') === 'product' || source === 'meta_paid') return 'us';
    if (q.get('market') === 'us' || q.get('market') === 'mx') return q.get('market');
    if (q.getAll('utm_source').map(lower).indexOf('ig-dm-mx') !== -1) return 'mx';
    if (source === 'brand_instagram' || source === 'alejandra') return detectedCountry === 'MX' ? 'mx' : 'us';
    return 'us';
  }
  function destination(source, market, sku, tagged) {
    if (SOURCES.indexOf(source) === -1) source = 'website_other';
    market = market === 'mx' && source !== 'meta_paid' ? 'mx' : 'us';
    var base = LINKS[source + '_' + market];
    // Mexico social links use their supplied default listing; the SKU map is for Amazon US.
    var asin = market === 'us' ? ASINS[mappedSku(sku)] : 'B0FR9TNRWP';
    var url = new URL(base || ('https://www.amazon.com.mx/dp/' + asin));
    url.pathname = '/dp/' + asin;
    if (!tagged) url.search = '';
    return url.href;
  }
  function renderPage() {
    var root = document.getElementById('lsv-amazon-page');
    if (!root) return;
    var source = currentSource();
    if (p.get('entry') === 'product' && SOURCES.indexOf(p.get('lsv_source')) !== -1) source = p.get('lsv_source');
    var market = marketFor(location.search,source,country());
    var sku = mappedSku(p.get('sku'));
    var web = destination(source,market,sku,allowed());
    var go = document.getElementById('go');
    var fallback = document.getElementById('lsv-web');
    var hint = document.getElementById('hint');
    var es = market === 'mx';
    var message = es ? 'Toca para continuar en la app de Amazon' : 'Tap to continue in the Amazon app';
    document.documentElement.lang = es ? 'es' : 'en';
    document.querySelector('[data-t="pre"]').textContent = es ? 'Comprar en' : 'Buy on';
    // Restore the original single-button page, including during template updates.
    var marketLabel = document.getElementById('lsv-market');
    if (marketLabel) marketLabel.hidden = true;
    if (fallback) fallback.hidden = true;
    go.href = web;
    hint.textContent = message;
    var ua = navigator.userAgent || '';
    var android = /Android/i.test(ua);
    var ios = /iPhone|iPad|iPod/i.test(ua) || (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1);
    var inApp = /Instagram|FBAN|FBAV|Barcelona|TikTok|musical_ly|BytedanceWebview|Snapchat|Pinterest|LinkedInApp|Twitter/i.test(ua);
    var path = web.replace(/^https:\/\//,'');
    go.onclick = null;
    clearTimeout(timer);
    if (android) {
      go.href = 'intent://' + path + '#Intent;scheme=com.amazon.mobile.shopping.web;package=com.amazon.mShop.android.shopping;S.browser_fallback_url=' + encodeURIComponent(web) + ';end';
    } else if (ios && inApp) {
      go.href = 'com.amazon.mobile.shopping.web://' + path;
      // Restore the original behavior: after a tap, the next tap can use HTTPS.
      go.onclick = function () {
        hint.textContent = es ? 'Abriendo Amazon…' : 'Opening Amazon…';
        clearTimeout(timer);
        timer = setTimeout(function () {
          hint.textContent = message;
          go.href = web;
        },2500);
      };
    }
    var debug = document.getElementById('lsv-debug');
    if (p.get('lsv_debug') === '1') {
      debug.hidden = false;
      debug.textContent = JSON.stringify({source:source,market:market,sku:market === 'us' ? sku : DEFAULT_SKU,
        asin:new URL(web).pathname.split('/').pop(),attributionIncluded:allowed() && new URL(web).searchParams.has('maas'),destination:web},null,2);
    }
    if (!(ios && inApp) && p.get('lsv_debug') !== '1' && !(window.Shopify && window.Shopify.designMode) && !redirected) {
      redirected = true;
      // Restore the original automatic attempt. Browser and Shopify policies still apply.
      if (android) location.href = go.href;
      else location.replace(web);
    }
  }
  function privacyReady() { ready = true; capture(); refreshButtons(); renderPage(); }
  function start() {
    ['pointerdown','focusin','click','auxclick'].forEach(function (eventName) {
      document.addEventListener(eventName,function (event) {
        var button = event.target.closest && event.target.closest('[data-lsv-amazon]');
        if (button) updateButton(button);
      },true);
    });
    document.addEventListener('change',function () {setTimeout(refreshButtons,0);});
    document.addEventListener('shopify:section:load',refreshButtons);
    document.addEventListener('visitorConsentCollected',privacyReady);
    document.addEventListener('visibilitychange',function () {
      if (document.hidden) clearTimeout(timer);
      else if (ready) renderPage();
    });
    window.addEventListener('pageshow',function () {if(ready) {capture();refreshButtons();renderPage();}});
    // Product routing remains available even if the privacy API fails; attribution then stays off.
    refreshButtons();
    if (window.Shopify && window.Shopify.customerPrivacy) privacyReady();
    else if (window.Shopify && window.Shopify.loadFeatures) {
      window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],privacyReady);
      setTimeout(function () {if(!ready) privacyReady();},3000);
    } else privacyReady();
  }
  window.LSVAmazon = {version:'2.1',classify:classify,largeSku:largeSku,mappedSku:mappedSku,
    destination:destination,marketFor:marketFor,currentSource:currentSource,refresh:refreshButtons};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start);
  else start();
})();
